var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSyteDiscoveryProductOrangeMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 5,
    fill: "#FED100"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.0949 7.04332C25.0949 5.86235 24.1376 4.905 22.9566 4.905L18.9783 4.905L18.9783 3.21423L22.9566 3.21423C25.0714 3.21423 26.7857 4.92857 26.7857 7.04332L26.7857 11.0216L25.0949 11.0216L25.0949 7.04332Z",
    fill: "#202020"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.90507 7.04331C4.90507 5.86235 5.86244 4.905 7.04341 4.905L11.0217 4.905L11.0217 3.21423L7.04341 3.21423C4.92865 3.21423 3.21429 4.92857 3.21429 7.04331L3.21429 11.0216L4.90507 11.0216L4.90507 7.04331Z",
    fill: "#202020"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.9566 25.0949C24.1376 25.0949 25.0949 24.1375 25.0949 22.9566L25.0949 18.9783L26.7857 18.9783L26.7857 22.9566C26.7857 25.0713 25.0714 26.7856 22.9566 26.7856L18.9783 26.7856L18.9783 25.0949L22.9566 25.0949Z",
    fill: "#202020"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.90507 22.9566C4.90507 24.1375 5.86244 25.0949 7.04341 25.0949L11.0217 25.0949L11.0217 26.7856L7.04341 26.7856C4.92865 26.7856 3.21429 25.0713 3.21429 22.9566L3.2143 18.9783L4.90507 18.9783L4.90507 22.9566Z",
    fill: "#202020"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4367 14.0054C17.4367 15.8181 15.9673 17.2875 14.1546 17.2875C12.342 17.2875 10.8725 15.8181 10.8725 14.0054C10.8725 12.1928 12.342 10.7234 14.1546 10.7234C15.9673 10.7234 17.4367 12.1928 17.4367 14.0054ZM17.0223 18.0686C16.212 18.6416 15.2226 18.9783 14.1546 18.9783C11.4082 18.9783 9.18176 16.7518 9.18176 14.0054C9.18176 11.259 11.4082 9.03259 14.1546 9.03259C16.9011 9.03259 19.1275 11.259 19.1275 14.0054C19.1275 15.0734 18.7909 16.0627 18.2179 16.8731L21.7144 20.3696L20.5189 21.5651L17.0223 18.0686Z",
    fill: "#202020"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSyteDiscoveryProductOrangeMobile);
export default __webpack_public_path__ + "static/media/syte-discovery-product-orange-mobile.7b1cce10.svg";
export { ForwardRef as ReactComponent };